import type { Cache, UpdatesConfig, Variables } from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

import type { AgentCreateMutation } from '@/graphql/generated/graphql';

const agentMutations: UpdatesConfig['Mutation'] = {
  agentCreate: (data: AgentCreateMutation, __: Variables, cache: Cache) => {
    if (data.agentCreate) {
      invalidateQuery('agents', cache);
    }
  },
};

export default agentMutations;
